import { v4 as uuidv4 } from 'uuid';
import { ShipmentType } from '../baskets/model';
import { ShippingMethodId } from '../baskets/model/ShippingMethodId';
import { toOrderAddress } from './store-utils';
import type { OrderAddress, Shipment } from '../baskets/model';
import type { Store } from '../stores/model';

export const DEFAULT_SHIPMENT: Shipment = { shipmentId: 'me' };

const buildShipment = (
    shippingMethodId: ShippingMethodId,
    shipmentType: ShipmentType,
    shippingAddress: OrderAddress,
    store?: Store,
): Shipment => ({
    shipmentId: uuidv4(),
    shippingAddress,
    shippingMethod: {
        id: shippingMethodId,
        c_storePickupEnabled: shippingMethodId === ShippingMethodId.BOPIS,
    },
    c_shipmentType: shipmentType,
    c_fromStoreId: store?.id,
});

export const buildBopisShipment = (store: Store): Shipment =>
    buildShipment(ShippingMethodId.BOPIS, ShipmentType.BOPIS, toOrderAddress(store)!, store);

export const buildSddShipment = (shippingAddress: OrderAddress, store?: Store): Shipment =>
    buildShipment(
        ShippingMethodId.SAME_DAY_DELIVERY,
        ShipmentType.SAME_DAY_DELIVERY,
        shippingAddress,
        store,
    );
